module.exports = __webpack_public_path__ + "static/workshop-hero-41753fa7a14152ac501db0ffe9c1f82f.jpg";